// React
import React from 'react';
import classNames from 'classnames';
//Styles
import useStyles from './StoreScheduleTableHeader.styles';

const StoreScheduleTableHeader = ({ classes, day, open, close, schedules }) => {
  const componentClasses = useStyles();

  return (
    <div className={classNames(componentClasses.root, classes.root)}>
      <div
        className={classNames(componentClasses.cell, componentClasses.dayCell)}
      >
        {day}
      </div>
      <div
        className={classNames(componentClasses.cell, componentClasses.openCell)}
      >
        {open}
      </div>
      <div className={componentClasses.cell}>{close}</div>
    </div>
  );
};

StoreScheduleTableHeader.defaultProps = {
  classes: {},
  schedules: {},
};

export default StoreScheduleTableHeader;
